import { registerLocaleData } from '@angular/common';
import localeFi from '@angular/common/locales/fi';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth.interceptor';
import { forceLoginOnEntry } from './core/force-login';
import { PageTitleStrategy } from './core/page-title.strategy';
import { createFirebaseAuth, FIREBASE_AUTH, FIREBASE_OPTIONS } from './core/firebase-auth.provider';
import { environment } from '../environments/environment';

registerLocaleData(localeFi);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: LOCALE_ID, useValue: 'fi-FI' },
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    {
      provide: FIREBASE_AUTH,
      useFactory: () =>
        createFirebaseAuth(environment.firebase, environment.firebaseAuthEmulatorUrl),
    },
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: PageTitleStrategy },
    provideAppInitializer(forceLoginOnEntry),
  ],
};
